export default __webpack_public_path__ + "2ac17a2d1b4594de8be48ca6e7e62a1f.svg";